"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(MUITheme => ({
  navlist: {
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: 20,
    listStyle: "none",
    "& li": {
      width: "auto",
      padding: 0
    }
  },
  navLink: {
    textDecoration: "none",
    color: MUITheme.palette.text.lightGrey
  },
  navLinkActive: {
    borderBottom: "2px solid ".concat(MUITheme.palette.primary.main),
    paddingBottom: 3,
    color: MUITheme.palette.primary.main,
    fontWeight: 600,
    "&: visited": {
      borderBottom: "2px solid ".concat(MUITheme.palette.primary.main),
      paddingBottom: 3,
      color: MUITheme.palette.primary.main,
      fontWeight: 600
    }
  }
}));